module.exports = __webpack_public_path__ + "assets/img/left-icon.333c2ac2.svg";